import styled from "./Numerator.module.css"
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { db, auth } from "../../firebase/firebase";
import { onSnapshot } from "firebase/firestore";
const Numerator = () => {
const navigate = useNavigate()
 const eventCollectionRef = collection(db, "events")
    const [events, setEvents] = useState([]);
      useEffect(() => {
  if (!auth.currentUser) return;

  const studentID = auth.currentUser.uid;
  const q = query(
    collection(db, "events"),
    where("studentID", "==", studentID)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const today = new Date();
    const startOfDay = new Date(today.setHours(0,0,0,0));
    const endOfDay = new Date(today.setHours(24,0,0,0));

    const events = snapshot.docs
      .map(doc => {
        const d = doc.data();
        return { ...d, start: d.start.toDate() };
      })
      .filter(e => e.start >= startOfDay && e.start < endOfDay);

    setEvents(events);
  });

  return unsubscribe;
}, []);

  return (
    <>
    {events.length !== 0 ? <div className={styled.main}>
      {/* <AiOutlineShoppingCart className={styled.card} /> */}
      <h4 onClick={() => {
        navigate("/todays-lessons")
      }} className={styled.number}>{events.length} </h4> 
     </div> : null}
    </>
  )
}

export default React.memo(Numerator)